"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("../styles/DispatcherStoreDashboard.css");
var _strings = require("../common_features/utility/strings");
var _reactRouterDom = require("react-router-dom");
var _TechDispatcherComponent = _interopRequireDefault(require("../components/TechDispatcherComponent"));
var _RoutePath = _interopRequireDefault(require("../RoutePath"));
var _Services = require("../common_features/utility/Services");
var _helper = require("../common_features/utility/helper");
var _reactRedux = require("react-redux");
var _index = _interopRequireDefault(require("../common_features/assets/images/index"));
var _systemsReducer = require("../common_features/redux/reducers/systemsReducer");
var _gatewayReducer = require("../common_features/redux/reducers/gatewayReducer");
var _alertReducer = require("../common_features/redux/reducers/alertReducer");
var _roleReducer = require("../common_features/redux/reducers/roleReducer");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const TechDispatcher = () => {
  var _selectedStore$Organi, _selectedStore$Organi2;
  const timeOutRef = (0, _react.useRef)(null);
  const deleteSysId = (0, _react.useRef)(null);
  const store = {};
  const [storeAlertCount, setStoreAlertCount] = (0, _react.useState)([]);
  const {
    selectedStore
  } = (0, _reactRedux.useSelector)(state => state.stores);
  const {
    userScreenPref
  } = (0, _reactRedux.useSelector)(state => state.role);
  const {
    systems,
    partialSysLoading
  } = (0, _reactRedux.useSelector)(state => state.systems);
  const {
    gateways
  } = (0, _reactRedux.useSelector)(state => state.gateway);
  const {
    sysLoading
  } = (0, _reactRedux.useSelector)(state => state.systems);
  const {
    gateLoading
  } = (0, _reactRedux.useSelector)(state => state.gateway);
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const [deleteModal, setDeleteModal] = (0, _react.useState)(false);
  const [sensorEstablished, setSensorEstablished] = (0, _react.useState)(false);
  const [openErrorModal, setOpenErrorModal] = (0, _react.useState)(false);
  const [popupShow, setPopShow] = (0, _react.useState)(false);
  const [imageLoading, setImageLoading] = (0, _react.useState)(false);
  const [displayZoomImage, setDisplayZoomImage] = (0, _react.useState)(false);
  const [storeImage, setStoreImage] = (0, _react.useState)('');
  const {
    userInfo
  } = (0, _reactRedux.useSelector)(state => state.login);
  const dispatch = (0, _reactRedux.useDispatch)();
  const [openModal, setOpenModal] = (0, _react.useState)(false);
  const navigate = (0, _reactRouterDom.useNavigate)();
  const handleBack = () => {
    if (userInfo.userType === 4 || userInfo.userType === 5) {
      if (userScreenPref !== "" && sessionStorage.getItem("Dispatcher_Web_Mobile_View")) {
        dispatch((0, _roleReducer.setUserScreenPref)(""));
      }
      navigate(_RoutePath.default.manageStore.useLink);
    } else {
      navigate(_RoutePath.default.admin.useLink);
    }
  };

  /* Line 41 to 106 is to Handle the Delete System Modal Action that Uses Web Socket
    Check the remove System Function */
  const handlePartialDelete = item => {
    setDeleteModal(true);
    deleteSysId.current = item.systemId;
  };
  const handlefailureCancel = () => {
    setDeleteModal(false);
  };
  const handleFailureContinue = () => {
    setDeleteModal(false);
    (0, _helper.removeSystem)(setIsLoading, deleteSysId.current, timeOutRef, setSensorEstablished, navigate, setOpenErrorModal, deleteSysId, {
      selectedStore,
      dispatch,
      setStoreAlertCount,
      systemsLoading: _systemsReducer.systemsLoading,
      gatewayLoading: _gatewayReducer.gatewayLoading,
      store
    }).then(() => {
      setIsLoading(true);
    });
  };
  (0, _react.useImperativeHandle)(timeOutRef, () => ({
    onTimeout: () => {
      if (!sensorEstablished) {
        setOpenErrorModal(true);
        setIsLoading(false);
      }
    }
  }));
  const handleDeleteErrorRetry = () => {
    setOpenErrorModal(false);
    (0, _helper.removeSystem)(setIsLoading, deleteSysId.current, timeOutRef, setSensorEstablished, navigate, setOpenErrorModal, deleteSysId, {
      selectedStore,
      dispatch,
      setStoreAlertCount,
      systemsLoading: _systemsReducer.systemsLoading,
      gatewayLoading: _gatewayReducer.gatewayLoading,
      store
    }).then(() => {
      setIsLoading(true);
    });
  };
  const handleDeleteErrorCancel = () => {
    setOpenErrorModal(false);
  };
  const warningSystemModalData = {
    variant: "warning-modal",
    displayModal: deleteModal,
    modalHeaderIcon: true,
    displayCrossIcon: false,
    modalHeaderText: "Warning",
    modalHeaderTextStyle: {
      color: "#E00932"
    },
    modalDetailText: "Removing this system will remove all attached accessories. You will not lose any historical data previously collected.",
    modalDetailTextStyle: {
      fontSize: 16,
      color: "#333333",
      fontWeight: 400,
      lineHeight: "22px"
    },
    positiveActionButtonTitle: "Continue",
    negativeButtonActionTitle: "Cancel",
    positiveAction: () => handleFailureContinue(),
    negativeAction: () => handlefailureCancel()
  };
  const deleteErrorSystemModalData = {
    variant: "error-modal",
    displayModal: openErrorModal,
    modalHeaderIcon: true,
    displayCrossIcon: false,
    modalHeaderText: "Error",
    modalHeaderTextStyle: {
      color: "#E00932"
    },
    modalDetailText: "The requested action did not complete successfully, please try again.",
    modalDetailTextStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400,
      lineHeight: "22px"
    },
    positiveActionButtonTitle: "Retry",
    negativeButtonActionTitle: "Cancel",
    positiveAction: () => handleDeleteErrorRetry(),
    negativeAction: () => handleDeleteErrorCancel()
  };
  (0, _react.useEffect)(() => {
    dispatch((0, _systemsReducer.selectSystems)({}));
  }, []);
  const navigateToAddSystem = () => {
    navigate(_RoutePath.default.addSystem.useLink);
  };
  // const navigateToAddHub = () => {
  //   navigate(baseRoutes.addHub.useLink);
  // };
  const optionBtnClick = item => {
    const {
      StoreAlertsDetails
    } = _RoutePath.default;
    dispatch((0, _alertReducer.selectedAlertData)({
      ...item,
      id: item.id,
      storeId: selectedStore.storeId
    }));
    navigate(StoreAlertsDetails.useLink);
  };
  (0, _react.useEffect)(() => {
    const customCall = () => {
      (0, _helper.getSystemsData)(selectedStore, dispatch, navigate, setStoreAlertCount, _systemsReducer.systemsLoading, _gatewayReducer.gatewayLoading, setIsLoading, store);
    };
    customCall();
    if (selectedStore !== null && selectedStore !== void 0 && selectedStore.imageSubPath) {
      setImageLoading(true);
      (0, _helper.fetchImage)(selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.imageSubPath, setImageLoading, setStoreImage);
    }
  }, []);
  const handleSystemClick = (item, type) => {
    if ((selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.isActive) === true) {
      switch (type) {
        case "system":
          dispatch((0, _systemsReducer.selectSystems)({
            ...item
          }));
          navigate(_RoutePath.default.systemDetail.useLink);
          break;
        case "gateway":
          dispatch((0, _gatewayReducer.selectGateway)({
            ...item
          }));
          navigate(_RoutePath.default.gatewayDetail.useLink);
          break;
        case "detail":
          navigate(_RoutePath.default.StoreAlertList.useLink);
          break;
      }
    }
  };
  const handleSystemPartialClick = async (item, type) => {
    setIsLoading(true);
    const data = await (0, _Services.getSystemDetails)(item === null || item === void 0 ? void 0 : item.systemId);
    setIsLoading(false);
    if ((selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.isActive) === true) {
      dispatch((0, _systemsReducer.selectSystems)({
        ...data.data.data
      }));
      navigate(_RoutePath.default.addSystem.useLink);
    }
  };
  const handleModal = modal => {
    setOpenModal(modal);
  };
  (0, _react.useEffect)(() => {
    if (partialSysLoading && !isLoading) {
      setPopShow(true);
      dispatch((0, _systemsReducer.setPartialSysLoading)(false));
      setTimeout(() => {
        setPopShow(false);
      }, 12000);
    }
  }, []);
  const isSystemPresent = systems => {
    return systems.length ? true : false;
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_TechDispatcherComponent.default, {
    heading: "STORE DASHBOARD",
    subHeading: "ServiceConnect",
    separator: "|",
    handleBack: handleBack,
    string: _strings.techDipatcherStrings,
    name: selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.name,
    address: (0, _helper.isJSON)(selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.address) ? (0, _helper.bindAddress)(JSON.parse(selectedStore.address)) : selectedStore.address,
    Organization: (selectedStore === null || selectedStore === void 0 ? void 0 : (_selectedStore$Organi = selectedStore.Organizations) === null || _selectedStore$Organi === void 0 ? void 0 : _selectedStore$Organi.name) || (selectedStore === null || selectedStore === void 0 ? void 0 : (_selectedStore$Organi2 = selectedStore.Organization) === null || _selectedStore$Organi2 === void 0 ? void 0 : _selectedStore$Organi2.name),
    headerText: "Welcome to your Store Dashboard!",
    btnTitle: "Add System",
    loginType: "dispatcher",
    navigateToAddSystem: navigateToAddSystem
    // navigateToAddHub={navigateToAddHub}
    ,
    handleModal: handleModal,
    openModal: openModal,
    positiveActionButtonTitle: "Ok",
    whatYourNeedContentArray: _strings.whatYouNeedContextArray,
    modalHeaderText: "What you need to know",
    modalTopContent: "You can add your system by part number, or we can assist you with a guided walk-through",
    systems: systems,
    gateways: gateways,
    onclick: handleSystemClick,
    sysLoading: sysLoading,
    gateLoading: gateLoading,
    systemType: "system",
    gatewayType: "gateway",
    waterDestinationItem: _strings.waterDestinationItem,
    successLabel: (selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.isActive) === true ? _strings.storeTileStrings.SUCCESS_LABEL : "Subscription Expired",
    rightButtonShow: selectedStore !== null && selectedStore !== void 0 && selectedStore.isActive ? isSystemPresent(systems) : false,
    everythingOkIcon: (selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.isActive) === true ? _index.default.everythingOkIcon.default : _index.default.subscriptionExpireIcon.default,
    dscIcon: (selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.isActive) === true ? _index.default.everythingOkIcon.default : _index.default.subscriptionExpireIcon.default,
    storeAlertList: storeAlertCount,
    optionBtnClick: optionBtnClick,
    isLoading: isLoading,
    onDetailsTileClick: () => {
      handleSystemClick(null, 'detail');
    },
    rightArrowBtn: selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.isActive,
    isDisable: selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.isActive,
    everythingOkText: selectedStore !== null && selectedStore !== void 0 && selectedStore.isActive ? _strings.storeTileStrings.SUCCESS_LABEL : "Monitoring Suspended",
    isSystem: isSystemPresent(systems),
    statusIcon: _index.default.greenDot.default,
    statusText: "Online",
    onPartialClick: handleSystemPartialClick,
    onPartialDelete: handlePartialDelete,
    deleteLogo: _index.default.deleteLogo.default,
    partialLogo: _index.default.timerLogo.default,
    deleteModal: deleteModal,
    openErrorModal: openErrorModal,
    warningSystemModalData: deleteModal ? warningSystemModalData : deleteErrorSystemModalData,
    popUpShow: popupShow,
    popUpStatusIcon: _index.default.everythingOkIcon.default,
    popUpStatusText: "System has been saved partially",
    systemsText: "Systems",
    storeImage: storeImage ? storeImage : _index.default.noImg.default,
    storeImageStyle: storeImage ? {
      width: "100%",
      height: "100%",
      borderRadius: 10
    } : {
      margin: "0px auto",
      height: "65px"
    },
    imageLoading: imageLoading,
    zoomImageAction: () => {
      setDisplayZoomImage(true);
    },
    displayZoomImage: displayZoomImage,
    crossIconAction: () => {
      setDisplayZoomImage(false);
    },
    userScreenPref: userScreenPref
  }));
};
var _default = exports.default = TechDispatcher;